import { handleActions } from 'redux-actions';

import { initialAccountWizardData, StagesConfig } from './InitialAccountWizardData';
import Immutable from 'immutable';

export const AccountWizardReducer = handleActions<any>(
  {
    SET_FORM_DATA: (state, action) => state.set('dataFields', Immutable.fromJS(action.payload)),
    RESET_WIZARD_DATA: state => initialAccountWizardData,
    CHANGE_FORM_FIELD: (state, action) => state.setIn(['dataFields', action.payload.name], action.payload.value),
    SET_STAGE: (state, action) => state.set('stage', action.payload),

    SET_STAGE_FORM: (state, action) => state.set('stageForm', action.payload),
    SET_SUBMITTED_STAGES: (state, action) => state.set('submittedStages', Immutable.fromJS(action.payload)),
    SET_ERROR: (state, action) => state.setIn(['errors', action.payload.name], action.payload.value),
    SET_INIT_COMPLETE: state => state.set('isInitialized', true),
    SET_CURRENT_STAGE_SUBMITTED: state => {
      const currentStageKey = StagesConfig[state.get('stage')].name;
      return state.setIn(['submittedStages', currentStageKey], true);
    },
    SET_FIRST_STAGE_SUBMITTED: state => {
      const currentStageKey = StagesConfig[0].name;
      return state.setIn(['submittedStages', currentStageKey], true);
    },
    SET_ERROR_POPUP: (state, action) => state.setIn(['errorPopup'], Immutable.fromJS(action.payload)),
    SET_AGREEMENTS_FORM_STAGE: (state, action) => state.setIn(['agreementsFormStage'], action.payload),
    ADD_PROTO_USER: (state, action) => state.setIn(['protoUsersList'], action.payload),
  },
  initialAccountWizardData
);
